import { ErrorState } from "@/components/ErrorState";
import Loader from "@/components/loader/Loader";
import TransferContainer from "@/components/shared/transfer/TransferContainer";
import { useSystemWalletDetails } from "@/hooks";
import type { Wallet } from "@/interfaces/wallet";
import { queryClient } from "@/services/queryClient";
import { makeRequest } from "@/utils/makeRequest";
import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

interface TransferPayload {
  assetId: string;
  networkId: string;
  to: string;
  amount: string;
  otp: string;
  securityCode: string;
}

const AdminTransfer = () => {
  const { systemType } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!systemType) return;
  }, [systemType]);

  const {
    data: adminWallet,
    isLoading: isLoadingWallet,
    isError,
    refetch,
  } = useSystemWalletDetails(systemType!);

  const transfer = async (payload: TransferPayload) => {
    setIsLoading(true);
    try {
      await makeRequest.post("/blockchain/transfer/system", payload);

      await queryClient.invalidateQueries({
        queryKey: ["wallet:details", systemType],
      });

      await queryClient.invalidateQueries({
        queryKey: ["wallets:system"],
      });

      setIsLoading(false);
      navigate;
      `/admin/wallets/${systemType}`;
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoadingWallet) {
    return <Loader type="bounce" />;
  }

  if (isError) {
    return (
      <ErrorState
        onRetry={() => {
          refetch();
        }}
      />
    );
  }
  return (
    <div>
      <TransferContainer
        wallet={adminWallet}
        onTransfer={transfer}
        isLoading={isLoading}
      />
    </div>
  );
};

export default AdminTransfer;
